// extracted by mini-css-extract-plugin
export default {"track":"VideoSlider_track__LOrbH"};